/**
 * Plugins à dépôt propre (ADR-ARCH-MODULAIRE-001). Le répertoire `HORALIIA_PLUGINS_DIR` est monté en
 * `/app/plugins` ; chaque plugin y porte `horaliia-plugin/ui/pages.ts` (pur : navigation et profils)
 * et `horaliia-plugin/ui/routes.tsx` (ses écrans, par chemin). Fichier pur, importé par familyConfig.
 * Sans montage, le glob est vide et l'application tourne sans plugin.
 */
import type { FamilyId, SidebarItem } from '@/layouts/familyConfig';

/** Une page de plugin : ses profils sont obligatoires (refus par défaut, jamais `null`). */
export interface PluginPage extends Omit<SidebarItem, 'profils'> {
  family: FamilyId;
  profils: string[];
}

export const PLUGIN_PAGES: PluginPage[] = Object.values(
  import.meta.glob<{ pages: PluginPage[] }>('../../plugins/*/horaliia-plugin/ui/pages.ts', { eager: true }),
).flatMap((m) => m.pages);
